import { action, observable } from 'mobx';
import user from '../../App/stores/UserStore';
import { get, post } from '../../../services/request';

const byDefaultDoNothing = () => {};
const overviewColumns = (t, onClick = byDefaultDoNothing) => [
  {
    key: 'itemNumber',
    name: t('Number'),
    fieldName: 'itemNumber',
    maxWidth: 100,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'agentName',
    name: t('Agent'),
    fieldName: 'agentName',
    minWidth: 100,
    maxWidth: 200,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'title',
    name: t('Title'),
    fieldName: 'title',
    minWidth: 200,
    maxWidth: 450,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'address',
    name: t('Address'),
    fieldName: 'address',
    minWidth: 200,
    maxWidth: 800,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'status',
    name: t('Status'),
    fieldName: 'status',
    minWidth: 200,
    maxWidth: 600,
    isSorted: false,
    isSortedDescending: false,
  },
];

class MlsStore {
  @observable items = [];
  @observable columns = [];
  @observable fetching = true;
  @observable loaded = false;

  constructor(user) {
    this.user = user;
  }

  @action sortBy(field) {
    const index = this.columns.findIndex((c) => c.key === field);
    const column = this.columns[index];
    this.items = this.items.sortBy(field, column.isSortedDescending);

    this.columns = this.columns.map((c, i) => {
      if (i !== index) {
        c.isSorted = false;
        c.isSortedDescending = false;
      } else {
        c.isSorted = true;
        c.isSortedDescending = !c.isSortedDescending;
      }
      return c;
    });
  }

  @action load() {
    this.fetching = true;
    get('/api/v1/sales/mls', this.user.accessToken).then(
      this.loadListingsOverviewSuccess,
      this.loadListingsOverviewError
    );
  }

  @action initColumns(t, onClick) {
    this.columns = overviewColumns(t, onClick);
  }

  @action.bound loadListingsOverviewSuccess(data) {
    this.items = data.objects.sortBy('startAt', false);
    this.fetching = false;
    this.loaded = true;
  }

  @action.bound loadListingsOverviewError(error) {
    this.fetching = false;
  }

  @action async requestAccess({ saleId, userId, agent }) {
    const res = await post(
      `/api/v1/sales/${saleId}/whitelist/request`,
      { userId, agent },
      this.user.accessToken
    );
    return res && res.result && res.result.successful;
  }
}

const mls = new MlsStore(user);

export default mls;
export { MlsStore };



// WEBPACK FOOTER //
// ./src/app/containers/Overview/stores/MlsStore.js